import React, { FC, ReactElement } from "react";
import { Button } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';

export interface IconButtonProps {
    text?: string;
}


export const DownloadButton = (props: IconButtonProps): ReactElement => {
    const {text} = props
    return (
    <Button variant="outlined" startIcon={<DownloadIcon />}>
        {text}
    </Button>
        )
}